import React from 'react';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import pages from '../../../../routes/pages';
import { useHistory } from 'react-router-dom';
import { getGoToPage } from '../../../../helpers/page/goToPage';
import useStyle from './backButton.style';

export interface BackButtonProps {
  disable?: boolean;
  shopId?: string;
  isVisible?: boolean;
  text?: string;
  onClick?: () => void;
}

export const BackButton = ({
  disable = false,
  shopId,
  isVisible = true,
  text,
  onClick
}: BackButtonProps) => {
  const classes = useStyle();
  const history = useHistory();
  const goHome = getGoToPage(history)(pages.PUBLIC_SHOP_HOME.path, shopId);
  const goBack = () => history.goBack();
  const handleClick = () => {
    if (disable) return goHome();
    if (onClick) return onClick();
    return goBack();
  };
  if (!isVisible) return null;
  return (
    <button className={classes.root} onClick={handleClick}>
      <FlatIcon icon="BackArrow" color="white" />
      <span>{text ? text : 'Retour aux résultats'}</span>
    </button>
  );
};
